export const STATUS_ENUMS = {
    Active: 1,
    Inactive: 2,
    Approved: 3,
    NotApproved: 4,
    Initial: 5,
    Final: 6,
    Closed: 7,
    Pending: 8,
    Completed: 9,
    InProgress: 10,
    Rejected: 11,
    Permanent: 12,
    Temporary: 13,
    Applicable: 14,
    NotApplicable: 15,
    Dispute: 16,
    DisputeClosed: 17,
    Analyze: 18,
    Mitigation: 19,
    InitialMitigation: 20,
    Monitering: 21,
    DisputeApprove: 22,
    RejectedAccept: 23,
    Resubmit: 24,
    Retrieve: 25,
    MitigationCompleted: 26,
    Draft: 30
}

export const TAB_COUNT_KEY = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    UNASSIGNED: 'unassigned'
}

export const HASH_STATUS_ENUMS = Object.fromEntries(Object.entries(STATUS_ENUMS).map(([ key, value ]) => [ value, key ]))
